import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminBoxQuantityHistoryReasonType } from '../enums/admin-box-quantity-history-reason-type';
import { AdminBoxQuantityHistoryReasonTypeProviderService } from '../providers/admin-box-quantity-history-reason-type-provider.service';

@Pipe({
  name: 'adminBoxQuantityHistoryReasonType',
})
export class AdminBoxQuantityHistoryReasonTypePipe implements PipeTransform {
  private readonly provider = inject(
    AdminBoxQuantityHistoryReasonTypeProviderService,
  );

  public transform(
    type: AdminBoxQuantityHistoryReasonType,
  ): Observable<string> {
    return this.provider.labelFor(type);
  }
}
